/**
 * Tiny browser-side CSV exporter used by the SFG / FG Investigation Queue
 * (and any other page that needs a one-click "Export CSV" of an already-
 * loaded array of plain objects).
 *
 *   exportArrayToCsv(rows, columns, filename)
 *
 *   columns: [{ key: 'sku_code', header: 'SKU' }, …]
 *
 * `key` may be a dot-path (e.g. 'customer.name') or a function
 * `(row) => string`. Values are CSV-escaped (quotes, commas, newlines).
 * If the browser is older than ~Edge 90, we fall back to a hidden anchor.
 */

const _csvEscape = (val) => {
  if (val === null || val === undefined) return '';
  if (Array.isArray(val)) val = val.join('|');
  const s = String(val);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

const _read = (row, key) => {
  if (typeof key === 'function') return key(row);
  if (!key.includes('.')) return row?.[key];
  return key.split('.').reduce((acc, k) => (acc == null ? acc : acc[k]), row);
};

export const exportArrayToCsv = (rows, columns, filename) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const headerLine = columns.map((c) => _csvEscape(c.header || c.key)).join(',');
  const dataLines = safeRows.map((row) =>
    columns.map((c) => _csvEscape(_read(row, c.key))).join(','),
  );
  // BOM keeps Excel happy with non-ASCII (₹ / ° / em-dash).
  const csv = '\uFEFF' + [headerLine, ...dataLines].join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
